const menus = [
	{
		"title": '概况',
		"icon": 'iconfont icon-gaikuang',
		"_src": 'index/index',
		"children": []
	},
	{
		"title": '小程序设置',
		"icon": 'iconfont icon-xiaochengxu',
		"children": [
			{"title": '企业官网',"_src": 'wxapp/home'},
			{"title": '入口名片',"_src": 'wxapp/entry'},
			{"title": '名片模板',"_src": 'wxapp/cards'},
			{"title": '微页面',"_src": 'wxapp/pages'},
			{"title": '动态表单',"_src": 'wxapp/forms'},
			{"title": '发布小程序',"_src": 'wxapp/publish'},
		]
	},
	{
		"title": '公司管理',
		"icon": 'iconfont icon-gongsi',
		"children": [
			{"title": '组织架构',"_src": 'company/index'},
			{"title": 'AI雷达权限',"_src": 'company/airadar'},
			{"title": '企业微信',"_src": 'company/wechat'},
		]
	},
	{
		"title": '客户管理',
		"icon": 'iconfont icon-kehu',
		"children": [
			{"title": '客户一览',"_src": 'clients/index'},
		]
	},
	{
		"title": '商城管理',
		"icon": 'iconfont icon-shangpin',
		"children": [
			{"title": '装修店铺',"_src": 'wxshop/index'},
			{"title": '产品管理',"_src": 'wxshop/goods'},
			//{"title": '规格管理',"_src": 'wxshop/attr'},
		]
	},
	{
		"title": '系统设置',
		"icon": 'iconfont icon-shezhi',
		"children": [
			{"title": '订阅消息',"_src": 'setting/message'},
			{"title": '海报缓存',"_src": 'poster/caches'},
		]
	},
	{
		"title": '我的账号',
		"icon": 'iconfont icon-wodedangxuan',
		"children": [
			{"title": '企业信息',"_src": 'user/detail'},
			{"title": '修改密码',"_src": 'user/password'},
		]
	},
	
],
plugins = [
	{"name": 'mtitle',"alias": '文本',"icon": 'iconfont icon-text'},
	{"name": 'media',"alias": '图片',"icon": 'iconfont icon-tupian'},
	{"name": 'swiper',"alias": '轮播',"icon": 'iconfont icon-lunbo'},
	{"name": 'freelayout',"alias": '自由布局',"icon": 'iconfont icon-rongqi'},
	{"name": 'buttons',"alias": '按钮',"icon": 'iconfont icon-anniu'},
	{"name": 'navigation',"alias": '导航',"icon": 'iconfont icon-daohang'},
	{"name": 'forms',"alias": '表单',"icon": 'iconfont icon-biaodan'},
	{"name": 'mmap',"alias": '地图',"icon": 'iconfont icon-ditu'},
	{"name": 'mvideo',"alias": '视频',"icon": 'iconfont icon-shipin'},
	{"name": 'webpage',"alias": 'Web页面',"icon": 'iconfont icon-wangyesheji'},
	{"name": 'product_list',"alias": '产品列表',"icon": 'iconfont icon-chanpin'},
	{"name": 'product_detail',"alias": '产品详情',"icon": 'iconfont icon-details'},
	{"name": 'official_account',"alias": '公众号关注',"icon": 'iconfont icon-guanzhugzh'},
	{"name": 'miniprogram',"alias": '小程序跳转',"icon": 'iconfont icon-miniprogram'},
];

export {menus, plugins}


// WEBPACK FOOTER //
// ./src/common/sidebar_data.js